/**
 * @desc 获取sku明细库存
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.stock.StockSkuGetAllQry>, options?: any) {
  return updateResponse(
    http(URL + `/stock/sku/getSkuDetailStock`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
